var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7158 14.9735H5.49585C5.08185 14.9735 4.74585 14.6375 4.74585 14.2235C4.74585 13.8095 5.08185 13.4735 5.49585 13.4735H12.7158C13.1298 13.4735 13.4658 13.8095 13.4658 14.2235C13.4658 14.6375 13.1298 14.9735 12.7158 14.9735Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7158 10.787H5.49585C5.08185 10.787 4.74585 10.451 4.74585 10.037C4.74585 9.62299 5.08185 9.28699 5.49585 9.28699H12.7158C13.1298 9.28699 13.4658 9.62299 13.4658 10.037C13.4658 10.451 13.1298 10.787 12.7158 10.787Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25048 6.61023H5.49548C5.08148 6.61023 4.74548 6.27423 4.74548 5.86023C4.74548 5.44623 5.08148 5.11023 5.49548 5.11023H8.25048C8.66448 5.11023 9.00048 5.44623 9.00048 5.86023C9.00048 6.27423 8.66448 6.61023 8.25048 6.61023Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_697_3410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18.1647V19.9098H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_697_3410)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9088 1.49982L5.21976 1.50382C2.89176 1.51782 1.49976 2.95782 1.49976 5.35682V14.5528C1.49976 16.9678 2.90476 18.4098 5.25576 18.4098L12.9448 18.4068C15.2728 18.3928 16.6648 16.9508 16.6648 14.5528V5.35682C16.6648 2.94182 15.2608 1.49982 12.9088 1.49982ZM5.25676 19.9098C2.11276 19.9098 -0.000244141 17.7568 -0.000244141 14.5528V5.35682C-0.000244141 2.12382 2.04676 0.0228169 5.21476 0.00381689L12.9078 -0.000183105H12.9088C16.0528 -0.000183105 18.1648 2.15282 18.1648 5.35682V14.5528C18.1648 17.7848 16.1178 19.8868 12.9498 19.9068L5.25676 19.9098Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.3782641b0f264c98b4ed89d2db14f78b.svg";
export { ForwardRef as ReactComponent };